import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common'
import { LookupValuesService } from '../common/lookup-values.service';
import { environment } from 'src/environments/environment';
import { utility } from '../common/utility';
import { AppBreadcrumbService } from '../app.breadcrumb.service';
import { ReportService } from 'src/app/services/ReportService';
import { AlertService } from '../services/AlertService';
import { AccountService } from '../services/AccountService';

export interface IReportParameter {

  label: string

  controlType: string;

  inputType: string

  key: string

  options?: any[];

  multiple?: boolean;

  value: any;
}


@Component({
  selector: 'app-report-view',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {


  cols: any[] = [];
  reports: any[] = [];

  blob: any; 
  currentReportParameters: IReportParameter[] = []

  dialogHeader: string = '';
  displayDialog: boolean = false;

  reportName: string = '';
  reportFormatOptions: any[];
  reportFormat: any = "PDF";
    reportRadioValue: any;
    isAdminOrOfficeManager: boolean = false;

    constructor(private lookupService: LookupValuesService, public datepipe: DatePipe, public breadcrumbService: AppBreadcrumbService,
        private alertService: AlertService, public reportService: ReportService, public accountService: AccountService) {

  }

  ngOnInit() {
    this.breadcrumbService.setItems([
      this.breadcrumbService.report
  ]);
    this.cols = [
        { field: 'Id', header: 'Id', display: 'none' },
        { field: 'ReportName', header: 'Name', display: 'table-cell' },
        { field: 'ClickFunction', header: '', display: 'None' }
    ];

    this.reports = [
        { ReportName: 'All NAI Parents Firms with Territories', ClickFunction: 'GenerateAllNAIParentFirms' },
        { ReportName: 'NAI Broker History - Assignment Initiated', ClickFunction: 'GenerateAssignmentInitiated' },
        { ReportName: 'NAI Broker History - Assignment Received', ClickFunction: 'GenerateAssignmentReceived' },
    ];
    this.reportFormatOptions = [
        { label: 'PDF', value: 'PDF' },
        { label: 'CSV', value: 'CSV' }
      ];
      this.isAdminOrOfficeManager = this.accountService.IsAdminOrIsOfficeManager;
  }
  onHideReportDialog($event) {

  }

  setHeaderAndShow()
  {
    this.dialogHeader = "";
    this.dialogHeader =  this.reportName;
    this.displayDialog = true;
  }
  GenerateAssignmentReceived() {
    this.reportName = 'NAI Broker History - Assignment Received';
    let parameters: IReportParameter[] = [];
    parameters.push({ label: 'Start Date', inputType: 'date', controlType: 'textbox', key: 'StartDate', value: null });
    parameters.push({ label: 'End Date', inputType: 'date', controlType: 'textbox', key: 'EndDate', value: null });
     this.currentReportParameters = parameters;
    this.setHeaderAndShow();
  } 
 

  GenerateAllNAIParentFirms() {
    this.currentReportParameters = [];
    this.reportName = 'All NAI Parent Firms';
    this.setHeaderAndShow();
  }

  GenerateAssignmentInitiated() {
    this.reportName = 'NAI Broker History - Assignment Initiated';
    let parameters: IReportParameter[] = [];
    parameters.push({ label: 'Start Date', inputType: 'date', controlType: 'textbox', key: 'StartDate', value: null });
    parameters.push({ label: 'End Date', inputType: 'date', controlType: 'textbox', key: 'EndDate', value: null });
    this.currentReportParameters = parameters;
    this.setHeaderAndShow();
  }

  // GetReport() {

  //   this.displayDialog = false;
  //   let reportURL = environment.apiBase.concat("Reports/GetMemberReport?ReportName=" + this.reportName);   
  //   reportURL += '&ReportFormat=' + this.reportFormat;


  //   this.currentReportParameters.forEach(param => {
  //     let name = param.key;
  //     let value = null;

     

  //     switch (param.controlType) {
  //       case 'radio':
  //         {
  //           value = this.getInputValue(name, param.inputType);
  //           break;
  //         }
  //       case 'textbox':
  //         {
  //           value = this.getInputValue(name, param.inputType);
  //           break;
  //         }
  //       case 'select': {
  //         value = this.getSelectValue(param);
  //         break;
  //       }
  //     }

  //     if (value == null || value == "null") {
  //       reportURL = reportURL.concat('&', name, ':isnull=true');
  //     }
  //     else {
  //       if (param.multiple) {
  //         value.forEach(val => {
  //           reportURL = reportURL.concat('&', name, '=', val);
  //         })
  //       }
  //       else {
  //         reportURL = reportURL.concat('&', name, '=', value);
  //       }
  //     }
  //   });

    
  //   console.log(reportURL);
  //   //window.open(reportURL, "popup");
  //   document.location.href = reportURL;

   
  // }

  GetReport() {

    this.displayDialog = false;
    let reportParamModel = new Map<string, string>();
    reportParamModel.set("ReportName",  this.reportName);
    reportParamModel.set("ReportFormat",  this.reportFormat);
    
    this.currentReportParameters.forEach(param => {
      let name = param.key;
      let value = null;

      switch (param.controlType) {
        case 'radio':
          {
            value = this.getInputValue(name, param.inputType);
            break;
          }
        case 'textbox':
          {
            value = this.getInputValue(name, param.inputType);
            break;
          }
        case 'select': {
          value = this.getSelectValue(param);
          break;
        }
      }

      if (value == null || value == "null") {
        reportParamModel.set(name, value);
      }
      else {
        if (param.multiple) {
          value.forEach(val => {
            reportParamModel.set(name, val);;
          })
        }
        else {
          reportParamModel.set(name, value);
        }
      }
    });

    this.reportService.GetMemberReport(reportParamModel).subscribe(     
      (data) => {

      if(this.reportFormat == 'PDF')
      {
        this.blob = new Blob([data], {type: 'application/pdf'});
      }
      else(this.reportFormat == 'CSV')
      {
        this.blob = new Blob([data], {type: 'text/csv'});
      }
    
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = this.reportName + '.'+ this.reportFormat;
      link.click();
    
    },
    error => {
      this.alertService.SetMessage('error', 'There is an error while generating the report');
      }
    );
    
   
  }

  private getInputValue(paramKey: string, paramInputType: string) {
    let value = null;

    if (paramInputType == 'text') {
      value = (<HTMLInputElement>document.getElementById(paramKey)).value;
    }
    else if (paramInputType == 'date') {
      let element = (<HTMLInputElement>document.getElementById(paramKey)).firstElementChild.firstElementChild;
      value = (<HTMLInputElement>element).value;
      if (paramKey.includes('EndDate')) {
        if (value != undefined) {
          var d = new Date(value);
          var endOfDayDate = new Date(d.getFullYear()
            , d.getMonth()
            , d.getDate()
            , 23, 59, 59);
        }
        value = this.datepipe.transform(endOfDayDate, "yyyy-MM-ddTHH:mm:ss");
      }
    }
    else if (paramInputType == 'radio') {
      let radioVal = (<HTMLInputElement>document.getElementById(paramKey)).checked;
      if (radioVal) {
        value = true;
      }
      else {
        value = false;
      }
    }

    return value;
  }

  private getSelectValue(param: IReportParameter) {

    return param.value;

  }

  onSelectedChange($event, param) {
    param.value = $event.value;

  }

  MaskDate(event) {
    utility.MaskDate(event);
    }

    showGetReport(report) {
        var result = false;
        switch (report.ReportName) {
            case 'All NAI Parents Firms with Territories': result = true; break;
            case 'NAI Broker History - Assignment Initiated': result = this.isAdminOrOfficeManager; break
            case 'NAI Broker History - Assignment Received': result = this.isAdminOrOfficeManager; break;
        }
        return result;
    }
}
